var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie"},[_vm._m(0),_c('div',{ref:"target",staticStyle:{"width":"100%","height":"300px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h3',[_vm._v("产品标签分布")]),_c('span',[_vm._v("(工单创建时间)")])])
}]

export { render, staticRenderFns }